function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconRefresh = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15.001 15"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h15v15H0z",
  style: {
    fill: "transparent"
  },
  transform: "translate(.001)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.584 12.133V14.7h-1.3v-5h5V11H2.363A6.2 6.2 0 1 0 1.3 7H0a7.5 7.5 0 1 1 1.584 5.133",
  style: {
    fill: "#434343"
  },
  transform: "rotate(180 7.492 7.5)"
}));
export default SvgIconRefresh;